export default __webpack_public_path__ + "static/media/SDG2.082fe189.png";